import { isAuthenticated, isTwoFactorRequired } from './guardService';

export default async (to) => {
    if (to.meta.twoFactorRequired || !isAuthenticated() || !isTwoFactorRequired()) {
        return true;
    }

    return {
        name: "require-two-factor"
    };
};
